export const base64ToUint8Array = (base64: string): Uint8Array<ArrayBuffer> => {
  const binString = atob(base64);
  return Uint8Array.from(binString, (m) => m.charCodeAt(0));
};

export const uint8ArrayToBase64 = (array: Uint8Array) => {
  const bytes = new Uint8Array(array);
  const binaryString = String.fromCharCode(...bytes);
  const base64String = btoa(binaryString);
  return base64String;
};
